export enum DATA_API_EVENTS {
  /**
   * Whenever a user clicks to create a Data API.
   */
  CREATE_API = 'CREATE_API',
  /**
   * Whenever a user clicks to edit a Data API.
   */
  EDIT_API = 'EDIT_API',
  /**
   * Whenever a user clicks to navigate to the create page.
   * origin: empty-state OR main-page
   */
  NAV_TO_CREATE = 'NAV_TO_CREATE',
  /**
   * Whenever a user clicks to navigate to the edit page.
   * origin: main-page
   */
  NAV_TO_EDIT = 'NAV_TO_EDIT',
  /**
   * Whenever a user clicks to pause a Data API.
   */
  PAUSE_API = 'PAUSE_API',
  /**
   * Whenever a user clicks to resume a Data API.
   */
  RESUME_API = 'RESUME_API',
  /**
   * Whenever a user clicks to delete a Data API (after the "confirm" step).
   */
  DELETE_API = 'DELETE_API',
  /**
   * Whenever a user clicks the Docs link.
   * origin: no-instance-state OR main-page
   */
  DIRECT_TO_DOCS = 'DIRECT_TO_DOCS',
  /**
   * Whenever a user clicks to create an Aura instance because there is none that they can use to create a Data API.
   */
  NAV_TO_CREATE_INSTANCE = 'NAV_TO_CREATE_INSTANCE',
  /**
   * Whenever a user clicks to view the cURL command for a Data API.
   */
  VIEW_CURL_COMMAND = 'VIEW_CURL_COMMAND',
}
